import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuthStore } from '@/stores/auth';

export default function ProtectedRoute({ children }: { children: ReactNode }) {
  const user = useAuthStore((s) => s.user);
  const masterKey = useAuthStore((s) => s.masterKey);
  if (!user || !masterKey) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}
